import { ReactNode } from 'react'
import { atom, RecoilState, useRecoilState } from 'recoil'

interface Props {
  id?: string
  title: string
  heightState?: RecoilState<boolean>
  resizeButton?: boolean
  children: ReactNode
  className?: string
  fadeButtom?: boolean
}

export default function PanelContainer({
  id,
  title,
  heightState,
  resizeButton = false,
  children,
  className,
  fadeButtom = true,
}: Props) {
  const [panelOpen, setPanelOpen] = useRecoilState(
    heightState ?? atom({ default: true, key: '' })
  )

  return (
    <div
      className={`relative p-3 rounded-sm bg-slate-200 transition-all flex flex-col space-y-3 ${
        heightState === undefined
          ? 'h-full'
          : resizeButton === panelOpen
            ? 'h-1/4'
            : 'h-3/4'
      } ${className}`}
      id={id}
    >
      <div className="text-md text-zinc-700 mb-4">{title}</div>
      <div className="flex-grow overflow-y-hidden ">{children}</div>
      {!!heightState && (
        <>
          {resizeButton && (
            <div
              className="resize-button absolute rounded-full w-4 h-4 right-1/2 -bottom-2 translate-x-1/2
        border-2 border-zinc-500 bg-slate-50 cursor-pointer z-10"
              onClick={() => setPanelOpen((x) => !x)}
            >
              <img
                src={'/icons/chevrons-up-down.svg'}
                alt="resize icon"
                className="mx-auto"
              />
            </div>
          )}
          {fadeButtom && resizeButton === panelOpen && (
            <div className="absolute z-0 left-0 w-full bottom-0 h-12 bg-gradient-to-t from-slate-200 to-transparent"></div>
          )}
        </>
      )}
    </div>
  )
}
